import SuperSelect from "forms/SuperSelect"
import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { defaultFilterClasses } from "./FilterInput"
import { getAllLibraryTemplates } from "../../api/LibraryTemplate"
import { LibraryTemplate, LibraryTemplateType } from "@prisma/client"
import { LibraryTemplateResponse } from "../../types/Redux"

type Props = {
    value: number[]
    setFilter: (selected: number[]) => void
}

const QuestionnairesFilter = ({ value, setFilter }: Props) => {
    const { t } = useTranslation("")
    const [exercises, setExercises] = useState<LibraryTemplateResponse[] | null>(null)

    useEffect(() => {
        const fetchExercises = async () => {
            const response = await getAllLibraryTemplates(LibraryTemplateType.EXERCISE)
            setExercises(response)
        }
        fetchExercises()
    }, [])

    const items = useMemo(
        () => (exercises ? exercises.map(({ id, title }) => ({ id, label: title })) : []),
        [exercises]
    )
 
    return (
        <SuperSelect
            id={"exercises"}
            items={items}
            value={value}
            setValue={setFilter}
            placeholder={t("export.allExercises")}
            usePlaceholderAsAll
            classList={defaultFilterClasses}
            contentWidth="w-64"
            withSelectionIcon={true}
        />
    )
}

export default QuestionnairesFilter
